/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingstatusretrying2Inputs */

const en_crosspostingstatusretrying2 = /** @type {(inputs: Crosspostingstatusretrying2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrying…`)
};

const de_crosspostingstatusretrying2 = /** @type {(inputs: Crosspostingstatusretrying2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholung…`)
};

/**
* | output |
* | --- |
* | "Retrying…" |
*
* @param {Crosspostingstatusretrying2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingstatusretrying2 = /** @type {((inputs?: Crosspostingstatusretrying2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingstatusretrying2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingstatusretrying2(inputs)
	return de_crosspostingstatusretrying2(inputs)
});
export { crosspostingstatusretrying2 as "crosspostingStatusRetrying" }